import { formatDate } from '@angular/common';
import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { VmsCreditMemo } from 'src/app/model/vms-credit-memo';
import { VmsCreditMemoLineModel } from 'src/app/model/vms-credit-memo-line-model';
import { VMSGSTGROUPCODEMASTERModel } from 'src/app/model/vms-gst-group-code-master-model';
import { VMSHSNSACMASTERModel } from 'src/app/model/vms-hsn-sac-master-model';
import { VMSNATUREOFEXPENSEMASTERModel } from 'src/app/model/vms-nature-of-expense-master-model';
import { VMSPIHEADERSTRUCTUREMASTERModel } from 'src/app/model/vms-pi-header-structure-master-model';
import { CreditMemoService } from 'src/app/services/credit-memo.service';
import { CrudService } from 'src/app/services/crud.service';
import { PoheaderService } from 'src/app/services/poheader.service';

@Component({
  selector: 'app-salescredit-note',
  templateUrl: './salescredit-note.component.html',
  styleUrls: ['./salescredit-note.component.css']
})
export class SalescreditNoteComponent implements OnInit {
  UserName: any = '';
  PostedInvoiceNoList: any[] = [];
  PostedInvoiceNoDataList: any[] = [];
  PreInvoiceNoList: any[] = [];
  PreInvoiceNoDataList: any[] = [];
  AddressCodeList: any;
  CreditMemoModel: VmsCreditMemo;
  CreditMemoList: VmsCreditMemo[];
  CreditMemoLineModel: VmsCreditMemoLineModel;
  MastersList: any;
  LstHSNSACMaster: VMSHSNSACMASTERModel[] = [];
  TempLstHSNSACMaster: VMSHSNSACMASTERModel[] = [];
  LstGSTGroupCodeMaster: VMSGSTGROUPCODEMASTERModel[] = [];
  LstNatureOfExpenseMaster: VMSNATUREOFEXPENSEMASTERModel[] = [];
  LstPIHeaderStructureMaster: VMSPIHEADERSTRUCTUREMASTERModel[] = [];
  files: any[] = [];
  filesToUpload = [];
  FileUpload: any = [];
  disableSubmitBtn: boolean = false;
  today: any = new Date();
  @ViewChild('fileInputCR', { static: false }) InputVar: ElementRef;
  @ViewChild('ngPostedInvoiceNo', { static: false }) ngPostedInvoiceNo;
  @ViewChild('ngPreInvoiceNo', { static: false }) ngPreInvoiceNo;

  keyword = 'name';
  PreInvoiceNo = "";
  PostedInvoiceNo = "";
  dataLoad: boolean = false;

  selectPostedInvoiceNoEvent(item) {
    debugger;
    this.PreInvoiceNo = "";
    this.ngPreInvoiceNo.clear();
    this.ngPreInvoiceNo.close();
    this.CreditMemoModel.PostedInvoiceNo = item.id;
    if (!this.dataLoad && !this.CreditMemoModel.SubmittedFlag)
      this.GetPostedInvoiceDetails(this.CreditMemoModel.PostedInvoiceNo);
  }

  selectPreInvoiceNoEvent(item) {
    debugger;
    this.PostedInvoiceNo = "";
    this.ngPostedInvoiceNo.clear();
    this.ngPostedInvoiceNo.close();
    this.CreditMemoModel.PreInvoiceNo = item.id;
    if (!this.dataLoad && !this.CreditMemoModel.SubmittedFlag)
      this.GetPreInvoiceDetails(this.CreditMemoModel.PreInvoiceNo);
  }
  onPreFocused(e) {
    this.ngPreInvoiceNo.open();
    this.dataLoad = false;
  }
  onPostedFocused(e) {
    this.ngPostedInvoiceNo.open();
    this.dataLoad = false;
  }
  onChangeSearch(val: string) {
  }

  constructor(private CreditMemoSer: CreditMemoService, private POHeaderSer: PoheaderService
    , private toasterSer: ToastrService, private route: ActivatedRoute,
    private spinner: NgxSpinnerService, private CrudSer: CrudService
  ) {
    this.UserName = sessionStorage.getItem("UserName");
    this.CreditMemoLineModel = new VmsCreditMemoLineModel();
    this.CreditMemoModel = new VmsCreditMemo();


  }

  ngOnInit() {
    this.route.queryParams
      .subscribe(params => {
        this.CreditMemoModel.SalesCreditNo = params['CreditMemoNo'] || null;
      });
    this.GetCreditMemoPostedInvoiceList();
    this.GetCreditMemoPreInvoiceList();
    this.GetAllMasters();
    if (this.CreditMemoModel.SalesCreditNo == null)
     {
    }
    else {
      this.GetCreditMemoByNo(this.CreditMemoModel.SalesCreditNo);

    }
  }

  FillHsnDropDown() {
    this.LstHSNSACMaster = this.TempLstHSNSACMaster.filter((S: VMSHSNSACMASTERModel) => S["HSNSAC_GST_GROUP_CODE"] == this.CreditMemoLineModel.GstGroupCode);
  }

  GetAllMasters() {
    let promise = new Promise((resolve, reject) => {
      this.POHeaderSer.GetAllMasters().toPromise()
        .then(
          res => {
            this.TempLstHSNSACMaster = res.Data[0];
            this.LstGSTGroupCodeMaster = res.Data[2];
            this.LstNatureOfExpenseMaster = res.Data[4];
            this.LstPIHeaderStructureMaster = res.Data[6];
            resolve('success');
          }
        );
    });
    return promise;
  }

  GetCreditMemoPostedInvoiceList() {
    this.CreditMemoSer.GetAllPostedInvoiceNoByVNo(this.UserName).subscribe(
      res => {
         if (res.Status) {
          debugger;
          this.PostedInvoiceNoList = res.Data;
          this.PostedInvoiceNoList.forEach(element => {
            this.PostedInvoiceNoDataList.push({ id: element.PstdInvNo, name: element.VendInvNo });
          });
        }
      },
      error => {
        console.log(error);
        console.error();
      }
    );
  }

  GetCreditMemoPreInvoiceList() {
    this.CreditMemoSer.GetAllPreInvoiceNoByVNo(this.UserName).subscribe(
      res => {
        if (res.Status) {
          debugger;
          this.PreInvoiceNoList = res.Data;

          this.PreInvoiceNoList.forEach(element => {
            this.PreInvoiceNoDataList.push({ id: element.PreInvNo, name: element.VendInvNo });
          });


        }
      },
      error => {
        console.log(error);
        console.error();
      }
    );
  }



  EditLienItem(item) {
    this.CreditMemoLineModel.GstGroupCode = item.GstGroupCode;
    this.CreditMemoLineModel.NatureOfExpense = item.NatureOfExpense;
    this.CreditMemoLineModel.Quantity = item.Quantity;
    this.CreditMemoLineModel.HSNSAC = item.HSNSAC;
    this.CreditMemoLineModel.DUC = item.DUC;
  }


  ResetForm() {
    this.CreditMemoLineModel = new VmsCreditMemoLineModel();
    this.CreditMemoModel = new VmsCreditMemo();
    this.InputVar.nativeElement.value = "";
  }
  ResetLine() {
    this.CreditMemoLineModel = new VmsCreditMemoLineModel();
  }
  ValidateCrMemo() {
    debugger;
    if ((this.CreditMemoModel.PostedInvoiceNo == "" || this.CreditMemoModel.PostedInvoiceNo == null ||
      this.CreditMemoModel.PostedInvoiceNo == undefined)
      && (this.CreditMemoModel.PreInvoiceNo == "" || this.CreditMemoModel.PreInvoiceNo == null ||
        this.CreditMemoModel.PreInvoiceNo == undefined)) {
      this.toasterSer.warning("Please select Either Vendor Invoice No. Or Invoice Reference No. (Pre)");
      return true;

    }

    if (this.CreditMemoModel.InvoiceDate == undefined || this.CreditMemoModel.InvoiceDate == "" || this.CreditMemoModel.InvoiceDate == null) {
      this.toasterSer.warning("Please enter Invoice Date");
      return true;

    }

    if (this.CreditMemoModel.VendorCreditMemoNo == undefined || this.CreditMemoModel.VendorCreditMemoNo == "" || this.CreditMemoModel.VendorCreditMemoNo == null) {
      this.toasterSer.warning("Please enter Vendor credit Memo No");
      return true;

    }
    if (this.CreditMemoModel.Remark == undefined ||this.CreditMemoModel.Remark == "" || this.CreditMemoModel.Remark == null) {
      this.toasterSer.warning("Please enter Remarks");
      return true;

    }
    if (this.CreditMemoModel.ContactEmail == undefined || this.CreditMemoModel.ContactEmail == "" || this.CreditMemoModel.ContactEmail == null) {
      this.toasterSer.warning("Please enter Email");
      return true;

    }
    if (this.CreditMemoModel.cMLineModels.length <= 0) {
      this.toasterSer.warning("No line is present");
      return true;

    }


    if (this.files.length <= 0) {
      this.toasterSer.warning('Please upload files!');
      return true;
    }
    return false;

  }

  alphaNumberOnly(e) {  // Accept only alpha numerics, not special characters 
    var regex = new RegExp("^[a-zA-Z0-9 ]+$");
    var str = String.fromCharCode(!e.charCode ? e.which : e.charCode);
    if (regex.test(str)) {
      return true;
    }

    e.preventDefault();
    return false;
  }


  DeleteLine(index) {
    if (confirm('Do you want to delete this Line')) {

      debugger;
      this.CreditMemoModel.cMLineModels.splice(index, 1);
     // this.SaveCreditMemo('DRAFT');
    }
  }

  convertDate(inputFormat) {
    function pad(s) { return (s < 10) ? '0' + s : s; }
    var d = new Date(inputFormat)
    return [pad(d.getDate()), pad(d.getMonth() + 1), d.getFullYear()].join('/')
  }

  ValidateDate() {
    debugger;

    alert(this.CreditMemoModel.InvoiceDate);
  }


  GetDate(dt) {
    const dArr = dt.split("/");
    let dd = ("0" + dArr[0]).slice(-2);
    let mm = ("0" + dArr[1]).slice(-2);
    let yyyy = ("00" + dArr[2]).slice(-4);

    return `${dd}/${mm}/${yyyy}`;


    // let d = new Date(dt);
    // let ye = new Intl.DateTimeFormat('en', { year: 'numeric' }).format(d);
    // let mo = new Intl.DateTimeFormat('en', { month: '2-digit' }).format(d);
    // let da = new Intl.DateTimeFormat('en', { day: '2-digit' }).format(d);
    // //console.log(`${da}-${mo}-${ye}`);

    // return `${da}/${mo}/${ye}`;
  }


  GetDates(dt) {
    const dArr = dt.split("/");
    let dd = ("0" + dArr[1]).slice(-2);
    let mm = ("0" + dArr[0]).slice(-2);
    let yyyy = ("00" + dArr[2]).slice(-4);

    return `${dd}/${mm}/${yyyy}`;
  }

  SaveCreditMemo(Status: any) {
    if (Status == 'SUBMITTED') {

      if (this.ValidateCrMemo()) {
        return;
      }

      if (this.CreditMemoModel.SalesCreditNo == undefined || this.CreditMemoModel.SalesCreditNo == ""
        || this.CreditMemoModel.SalesCreditNo == null) {
        this.toasterSer.error('Calculate Tax before Submission');
        return;

      }
    }
    this.disableSubmitBtn = true;
    this.spinner.show(); 
    debugger;
    if (this.CreditMemoModel.InvoiceDate.toString().indexOf("/") <= -1) {
      this.CreditMemoModel.InvoiceDate = this.CreditMemoModel.InvoiceDate.toLocaleDateString();
      //new Date(this.CreditMemoModel.InvoiceDate); 
      this.CreditMemoModel.InvoiceDate = this.GetDates(this.CreditMemoModel.InvoiceDate);
    }
    else {
      this.CreditMemoModel.InvoiceDate = this.GetDate(this.CreditMemoModel.InvoiceDate);
    }

    if (this.CreditMemoModel.PreInvoiceNo == undefined || this.CreditMemoModel.PreInvoiceNo == '' || this.CreditMemoModel.PreInvoiceNo == null)
      this.CreditMemoModel.PreInvoiceNo = this.CreditMemoModel.PreAppliedDocumentNo;

    if (this.CreditMemoModel.PostedInvoiceNo == undefined || this.CreditMemoModel.PostedInvoiceNo == '' || this.CreditMemoModel.PostedInvoiceNo == null)
      this.CreditMemoModel.PostedInvoiceNo = this.CreditMemoModel.AppliedDocumentNo;

console.log(this.CreditMemoModel);

    let formData: FormData = new FormData();
    this.CreditMemoModel.Status = Status;
    formData.append("PostedInvoiceNo", this.CreditMemoModel.PostedInvoiceNo ? this.CreditMemoModel.PostedInvoiceNo : '');
    formData.append("PreInvoiceNo", this.CreditMemoModel.PreInvoiceNo ? this.CreditMemoModel.PreInvoiceNo : '');
    formData.append("VCrMemoNo", this.CreditMemoModel.VendorCreditMemoNo ? this.CreditMemoModel.VendorCreditMemoNo : '');
    formData.append("InvoiceDate", this.CreditMemoModel.InvoiceDate);
    formData.append("ContactEmail", this.CreditMemoModel.ContactEmail);
    formData.append("ReasonForRejection", this.CreditMemoModel.ReasonForRejection);
    formData.append("Remarks", this.CreditMemoModel.Remark);
    formData.append("Status", this.CreditMemoModel.Status);
    formData.append("VendorNo", this.UserName);
    formData.append("SalesCreditNo", this.CreditMemoModel.SalesCreditNo);
    formData.append("Pointofcontact", this.CreditMemoModel.Pointofcontact ? this.CreditMemoModel.Pointofcontact : '');
    formData.append("CreditLine", JSON.stringify(this.CreditMemoModel.cMLineModels));
    for (var i = 0; i < this.FileUpload.length; i++) {
      formData.append(this.FileUpload[i].name, this.FileUpload[i]);
    }

    let promise = new Promise((resolve, reject) => {
      this.CreditMemoSer.SaveCreditMemo(formData).toPromise()
        .then(
          res => {
           // this.spinner.hide();
            this.disableSubmitBtn = false;
            if (res.Status) {

              if (Status == "SUBMITTED") 
              {
                var str = 'Thank you for submitting the Credit Memo.Please ensure that the original copy of the submitted invoice reaches at below address within 5 working days.';
                str += 'To,';
                str += 'Vendor Help Desk';
                str += 'FICCI Federation House';
                str += '1, Tansen Marg';
                str += 'New Delhi- 110001';
                this.toasterSer.success(str, null, { closeButton: true, disableTimeOut: true });

              }
              else 
              {
                this.GetCreditMemoByNo(res.Data);  
                this.CreditMemoModel.SalesCreditNo = res.Data;
                //this.toasterSer.success('Record saved successfully!');

                this.toasterSer.success('Record saved successfully!');
              }
              
              debugger;
              this.CreditMemoModel.SalesCreditNo = res.Data;
              this.GetCreditMemoByNo(res.Data);              
              this.spinner.hide();
            }
            else {
              this.toasterSer.error(res.Message);
              this.spinner.hide();
            }

            resolve(res);
          }
        );
    });
    // this.spinner.hide();
    return promise;
  }
  EditCreditLine(item) {

    this.CreditMemoLineModel = new VmsCreditMemoLineModel();
    this.CreditMemoLineModel.LineNo = item.LineNo;
    this.CreditMemoLineModel.Quantity = item.Quantity;
    this.CreditMemoLineModel.DUC = item.DUC;
    this.CreditMemoLineModel.GstGroupCode = item.GstGroupCode;
    this.CreditMemoLineModel.HSNSAC = item.HSNSAC;
    this.CreditMemoLineModel.NatureOfExpense = item.NatureOfExpense;
  }

  AddCreditMemoLine() {
    debugger;
    var indx = this.CreditMemoModel.cMLineModels.findIndex(x => x.LineNo == this.CreditMemoLineModel.LineNo);
   
    this.CreditMemoModel.cMLineModels.splice(indx, 1, this.CreditMemoLineModel);
    this.CreditMemoLineModel = new VmsCreditMemoLineModel();
  }

  uploadFile(event) {
    debugger;

    if (this.CreditMemoModel.AppliedDocumentNo == '' && this.CreditMemoModel.PreAppliedDocumentNo == '') {
      this.toasterSer.warning('Please select Either Vendor Invoice No Or Invoice Reference No. (Pre)');
      this.InputVar.nativeElement.value = "";
      return;

    }

    var totalsize =0;


    for (let index = 0; index < event.length; index++) {
      totalsize += event[index].size ; 
      //alert(totalsize);
    }

    if(totalsize>5242880)
    {
      alert("File Size is more than 5 MB");
      (<HTMLInputElement>document.getElementById("fileinput")).value='';    
      return;
    }
    
    for (let index = 0; index < event.length; index++) {
      const element = event[index];
      this.files.push({ name: element.name, DownloadFlag: false });
      this.FileUpload.push(event[index]);
    }
  }

  DownloadFile(FileName: string) {
    var formattedInvoiceNo = this.CreditMemoModel.AppliedDocumentNo.split('/').join('-');
    window.open(this.CrudSer.DownLoadURl + 'UploadedFiles/CreditMemo/' + this.UserName + "/" + formattedInvoiceNo + '/' + FileName);
  }

  DeleteDocument(FileName: string) {
    this.POHeaderSer.DeleteCRDocument(this.CreditMemoModel.AppliedDocumentNo, FileName, this.UserName).subscribe(
      data => {
        if (data) {
          this.toasterSer.success(data);
          this.GetAllCreditMemoDocuments(this.CreditMemoModel.AppliedDocumentNo);
        }
        else {
          //alert(data);
        }
      }, error => console.error());
  }

  deleteAttachment(index) {
    if (confirm('Do you want to delete this file')) {
      var Name = this.files[index].name;
      var UploadIndex = this.FileUpload.map(function (x) { return x.name; }).indexOf(Name);
      if (this.files[index].DownloadFlag) {
        this.DeleteDocument(Name);
      }
      else {
        this.FileUpload.splice(UploadIndex, 1);
        this.files.splice(index, 1);
      }
    }
  }

  GetCreditMemoByNo(CreditMemoNo: any) {
    this.spinner.show();
    this.POHeaderSer.GetAllCreditMemo(this.UserName, CreditMemoNo).subscribe(
      res => {

        debugger;
        console.log(res);
        this.dataLoad = true;


        this.CreditMemoModel = res.Data[0];

        this.CreditMemoModel.SalesCreditNo = CreditMemoNo;

        // this.CreditMemoModel.InvoiceDate = this.CreditMemoModel.InvoiceDate == null 
        // ? "" : this.CreditMemoModel.InvoiceDate.split(' ')[0];

        this.CreditMemoModel.InvoiceDate = this.CreditMemoModel.InvoiceDate == null ? "" : this.GetDate(this.CreditMemoModel.InvoiceDate);

        //  this.CreditMemoModel.InvoiceDate=formatDate(this.CreditMemoModel.InvoiceDate, 'dd/MM/yyyy', 'en_US');
        debugger;
        this.CreditMemoModel.PostedInvoiceNo = this.CreditMemoModel.AppliedDocumentNo;
        this.CreditMemoModel.PreInvoiceNo = this.CreditMemoModel.PreAppliedDocumentNo;

        let preInv = this.PreInvoiceNoDataList.find(x => x.id == this.CreditMemoModel.PreInvoiceNo);
        if (preInv != undefined)
          //this.PreInvoiceNo = preInv;// preInv.name;   //this.PreInvoiceNoDataList.find(x=>x.id == this.CreditMemoModel.PreInvoiceNo)// this.CreditMemoModel.PreRefInvoiceNo;
          this.PreInvoiceNo = preInv.name;
        let postInv = this.PostedInvoiceNoDataList.find(x => x.id == this.CreditMemoModel.PostedInvoiceNo);
        if (postInv != undefined)

        //this.PostedInvoiceNo = postInv;
          this.PostedInvoiceNo = postInv.name;// this.CreditMemoModel.PostedInvoiceNo;

        if (this.CreditMemoModel.AppliedDocumentNo != undefined && this.CreditMemoModel.AppliedDocumentNo != '' && this.CreditMemoModel.AppliedDocumentNo != null)
          this.GetAllCreditMemoDocuments(this.CreditMemoModel.AppliedDocumentNo);

        if (this.CreditMemoModel.PreAppliedDocumentNo != undefined && this.CreditMemoModel.PreAppliedDocumentNo != '' && this.CreditMemoModel.PreAppliedDocumentNo != null)
          this.GetAllCreditMemoDocuments(this.CreditMemoModel.PreAppliedDocumentNo);

       // this.CreditMemoModel.TotBaseAmount = this.CreditMemoModel.cMLineModels.reduce((accum, item) => accum + parseFloat(item.GstBaseAmt), 0)
       // this.CreditMemoModel.GSTTotal = this.CreditMemoModel.cMLineModels.reduce((accum, item) => accum + parseFloat(item.TotalGstAmt), 0)

      //  this.CreditMemoModel.GSTTotal = Number((this.CreditMemoModel.GSTTotal).toFixed(2));
       // this.CreditMemoModel.TotBaseAmount = Number((this.CreditMemoModel.TotBaseAmount).toFixed(2));

        this.spinner.hide();
      },
      error => {
        console.log(error);
        console.error();
      }
    );
  }

  GetAllCreditMemoDocuments(InvoiceNo: string) {
    this.POHeaderSer.GetAllCreditMemoDocuments(InvoiceNo, this.UserName).subscribe(
      data => {
        if (data.indexOf('Could not find a part of the path') <= -1) {
          this.files = [];
          if (data != null)
            data.forEach(element => {
              this.files.push({ name: element, DownloadFlag: true })
            });
        }
      }, error => console.error());

  }

  GetPreInvoiceDetails(invoiceNo: any) {
    this.spinner.show();
    debugger;

    var CrNo = this.CreditMemoModel.SalesCreditNo;
    this.CreditMemoModel = new VmsCreditMemo();
    //this.InputVar.nativeElement.value = "";

    this.CreditMemoSer.GetPreInvoiceDetails(invoiceNo).subscribe(
      res => {
        this.spinner.hide();
        if (res.Status) {

          debugger;
          console.log(res.Data);

          this.CreditMemoModel = res.Data;

          this.CreditMemoModel.PostedInvoiceNo = '';
          this.CreditMemoModel.SalesCreditNo = CrNo;
          this.files = [];
          debugger;
          this.CreditMemoModel.PreInvoiceNo = this.CreditMemoModel.AppliedDocumentNo;
          this.CreditMemoModel.PreAppliedDocumentNo = this.CreditMemoModel.PreInvoiceNo;
          this.CreditMemoModel.AppliedDocumentNo = '';
          //this.CreditMemoModel.InvoiceDate = this.CreditMemoModel.InvoiceDate == null ? "": formatDate(this.CreditMemoModel.InvoiceDate, 'dd/MM/yyyy', 'en_US');
          this.CreditMemoModel.InvoiceDate = this.CreditMemoModel.InvoiceDate == null ? "" : this.GetDate(this.CreditMemoModel.InvoiceDate);
          this.CreditMemoModel.TotBaseAmount = this.CreditMemoModel.cMLineModels.reduce((accum, item) => accum + parseFloat(item.GstBaseAmt), 0)
          this.CreditMemoModel.GSTTotal = this.CreditMemoModel.cMLineModels.reduce((accum, item) => accum + parseFloat(item.TotalGstAmt), 0)


        }


      },
      error => {
        console.log(error);
        console.error();
      }
    );
  }

  GetPostedInvoiceDetails(invoiceNo: any) {
    this.spinner.show();
    debugger;

    var CrNo = this.CreditMemoModel.SalesCreditNo;
    this.CreditMemoModel = new VmsCreditMemo();
    //this.InputVar.nativeElement.value = "";

    this.CreditMemoSer.GetPostedInvoiceDetails(invoiceNo).subscribe(
      res => {
        this.spinner.hide();
        if (res.Status) {
          this.CreditMemoModel = res.Data;
          this.CreditMemoModel.PreInvoiceNo = '';
          this.CreditMemoModel.SalesCreditNo = CrNo;
          this.files = [];
          debugger;
          this.CreditMemoModel.PostedInvoiceNo = this.CreditMemoModel.AppliedDocumentNo;
          this.CreditMemoModel.PreAppliedDocumentNo = '';
          //this.CreditMemoModel.InvoiceDate = this.CreditMemoModel.InvoiceDate == null ? "": formatDate(this.CreditMemoModel.InvoiceDate, 'dd/MM/yyyy', 'en_US');
          this.CreditMemoModel.InvoiceDate = this.CreditMemoModel.InvoiceDate == null ? "" : this.GetDate(this.CreditMemoModel.InvoiceDate);
          this.CreditMemoModel.TotBaseAmount = this.CreditMemoModel.cMLineModels.reduce((accum, item) => accum + parseFloat(item.GstBaseAmt), 0)
          this.CreditMemoModel.GSTTotal = this.CreditMemoModel.cMLineModels.reduce((accum, item) => accum + parseFloat(item.TotalGstAmt), 0)


        }


      },
      error => {
        console.log(error);
      }
    );
  }

  GetAddressCodes() {
    this.CreditMemoSer.GetAddressCodes().subscribe(
      res => {
        if (res.Status) {
          debugger;
          this.AddressCodeList = res.Data;
          //  this.AddressCodeList=this.AddressCodeList.filter(x=>x.VendorNo);
        }
      },
      error => {
        console.log(error);
        console.error();
      }
    );
  }
}